'use strict';
import { List, Map, OrderedMap } from 'immutable';
import { fixed } from '../../utils/formater';
import {APARTMENTS, DISTRICTS, RENT} from '../../consts';

class PillBuilder {
  constructor (currentFilter, territorial, dictionary, defaultFilter = null) {
    this.selected = currentFilter;
    this.territorial = territorial;
    this.default = defaultFilter || new Map();
    this.dictionary = dictionary;
  }

  getPills (dealType, realtyType) {
    const pills = new List([]);

    return pills
      .concat(this.parseOnlyOwners(dealType, realtyType))
      .concat(this.parseTerritory())
      .concat(this.parseValueItems())
      .concat(this.parseBoolItems())
      .concat(this.parseTrinityExistNoItems())
      .concat(this.parseTrinityYesNoItems())
      .concat(this.parseArraySelector())
      .concat(this.parseIdSelector())
      .filter(Boolean);
  }

  parseOnlyOwners (dealType, realtyType) {
    const key = 'onlyOwners';
    const noValue = !this.selected.get(key);

    if (noValue) {
      return [];
    }

    let label = 'частные';
    if (dealType === RENT && realtyType === APARTMENTS) {
      label = 'без комиссии';
    }

    return [{
      key,
      label,
      filter: {
        [key]: this.default.get(key)
      }
    }];
  }

  parseTrinityExistNoItems () {
    const keys = this.getTrinityExistNoItems();

    return keys.map((label, key) => {
      const value = parseInt(this.selected.get(key));
      if (value === 0 || value === 1) {
        let trinityLabel = label;

        if (parseInt(value) === 0) {
          trinityLabel += ': нет';
        }
        if (parseInt(value) === 1) {
          trinityLabel += ': есть';
        }

        return {
          key,
          label: trinityLabel,
          filter: {
            [key]: this.default.get(key)
          }
        };
      }
    }).filter(Boolean).toList();
  }

  parseTrinityYesNoItems () {
    const keys = this.getTrinityYesNoItems();

    return keys.map((label, key) => {
      const value = parseInt(this.selected.get(key));
      if (value === 1 || value === 2) {
        let trinityLabel = label;

        if (parseInt(value) === 2) {
          trinityLabel += ': нет';
        }
        if (parseInt(value) === 1) {
          trinityLabel += ': да';
        }

        return {
          key,
          label: trinityLabel,
          filter: {
            [key]: this.default.get(key)
          }
        };
      }
    }).filter(Boolean).toList();
  }

  parseBoolItems () {
    const keys = this.getBoolItems();

    return keys.map((label, key) => {
      if (this.selected.get(key)) {
        return {
          key,
          label,
          filter: {
            [key]: this.default.get(key)
          }
        };
      }
    }).filter(Boolean).toList();
  }

  parseTerritory () {
    const selectors = this.getTerritoryItems();

    const items = [];

    const mapItems = this.getMapItems();

    if (mapItems.get('bounds') || mapItems.get('areaPolygon')) {
      items.push({
        key: 'bounds',
        label: 'область на карте',
        filter: {
          bounds: this.default.get('bounds'),
          areaPolygon: this.default.get('areaPolygon')
        }
      });
    }

    selectors.map((selector, key) => {
      const value = this.selected.get(key);
      if (value) {
        const split = value.split(',') || [];

        split.map(id => {
          const item = this.territorial[selector](id);
          if (item) {
            items.push({
              key,
              label: item.name,
              filter: {
                [key]: split.filter(_id => _id !== id).join(',') || this.default.get(key)
              }
            });
          } else if (id === DISTRICTS.suburb) {
            items.push({
              key,
              label: 'Область',
              filter: {
                [key]: split.filter(_id => _id !== id).join(',') || this.default.get(key)
              }
            });
          }
        });
      }
    });

    return new List(items);
  }

  parseArraySelector () {
    const selectors = this.getArraySelector();
    const items = [];

    selectors.map((selector, key) => {
      const value = this.selected.get(key);
      if (value) {
        const split = value.split(',') || [];

        split.map(id => {
          const item = this.dictionary[selector](id);
          if (item) {
            items.push({
              key,
              label: item.get('fullName') || item.get('shortName'),
              filter: {
                [key]: split.filter(_id => _id !== id).join(',') || this.default.get(key)
              }
            });
          }
        });
      }
    });

    return new List(items);
  }

  parseIdSelector () {
    const selectors = this.getIdSelector();

    return selectors.map((selector, key) => {
      const id = this.selected.get(key);
      if (id) {
        const item = this.dictionary[selector](id);

        if (item) {
          return {
            key,
            label: item.get('shortName') || item.get('fullName'),
            filter: {
              [key]: this.default.get(key)
            }
          };
        }
      }
    }).filter(Boolean).toList();
  }

  parseValueItems () {
    const related = {
      address: {
        address: null,
        localityId: null,
        houseId: null,
        streetId: null
      }
    };

    const fields = this.getValueItems();

    return fields.map((template, key) => {
      const label = this.selected.get(key);
      if (label) {
        let value = template.replace('%s', label);

        if (template.indexOf('%d') !== -1) {
          value = template.replace('%d', fixed(label, 0));
        }

        return {
          key,
          label: value,
          filter: related[key] || {
            [key]: this.default.get(key)
          }
        };
      }
    }).filter(Boolean).toList();
  }

  getTerritoryItems () {
    return new OrderedMap({
      district: 'getLocalityDistrictById',
      microdistrict: 'getMicroDistrictById',
      regionDistrict: 'getRegionDistrictById',
      subwayId: 'getSubwayById'
    });
  }

  getMapItems () {
    return new OrderedMap({
      bounds: this.selected.get('bounds'),
      areaPolygon: this.selected.get('areaPolygon')
    });
  }

  getArraySelector () {
    return new OrderedMap({
      objectTypeId: 'getObjectType',
      planningId: 'getPlanning',
      sanitaryId: 'getSanitary',
      renovationTypeId: 'getRenovation',
      buildingTypeId: 'getBuildingType',
      materialId: 'getMaterial',
      usageCategoryId: 'getUsageCategory',
      heatingId: 'getHeating',
      furnitureId: 'getFurniture',
      sourceAppId: 'getApplication'
    });
  }

  getIdSelector () {
    return new OrderedMap({
      floorPositionId: 'getFloorPosition',
      windowTypeId: 'getWindowType',
      windowViewId: 'getWindowView',
      isCorner: 'getCorner',
      rentPeriodId: 'getRentPeriod',
      deadlineId: 'getDeadline',
      interval: 'getIntervalInserted',
      tenantCountPreferenceId: 'getPersonNumber',
      tenantGenderPreferenceId: 'getGender',
      dataSourceId: 'getDataSource'
    });
  }

  getTrinityExistNoItems () {
    return new OrderedMap({
      hasFridge: 'холодильник',
      hasBalcony: 'балкон/лоджия',
      hasTV: 'тв',
      hasWashingMachine: 'стир. машина',
      hasConditioning: 'кондиционер',
      hasInternet: 'интернет'
    });
  }

  getTrinityYesNoItems () {
    return new OrderedMap({
      isChildrenAllowed: 'с детьми',
      isAnimalsAllowed: 'с животными'
    });
  }

  getValueItems () {
    // TODO: в земле за сотку сделать
    const priceUnit = parseInt(this.selected.get('priceUnitId', 0)) === 2 ? '/м²' : '';
    return new OrderedMap({
      id: 'id: %s',
      address: '%s',
      priceMin: 'цена от %d ₽' + priceUnit,
      priceMax: 'цена до %d ₽' + priceUnit,
      contactPhone: 'телефон: %s',
      agencyId: 'объекты агенства: %s',
      userId: 'объекты пользователя: %s',
      builtYearMin: 'г. постр. от %s г.',
      builtYearMax: 'г. постр. до %s г.',
      distanceFromCityMin: 'до города от %d км',
      distanceFromCityMax: 'до города до %d км',
      floorMin: 'от %s этажа',
      floorMax: 'до %s этажа',
      floorTotalMin: 'дом не ниже %s эт.',
      numberOfBedsMin: 'спальных мест от %s',
      numberOfBedsMax: 'спальных мест до %s',
      squareTotalMin: 'общ.площ. от %s м²',
      squareTotalMax: 'общ.площ. до %s м²',
      squareLivingMin: 'жил.площ. от %s м²',
      squareLivingMax: 'жил.площ. до %s м²',
      squareKitchenMin: 'площ.кухни от %s м²',
      squareKitchenMax: 'площ.кухни до %s м²',
      squareLandMin: 'участок от %d сот.',
      squareLandMax: 'участок до %d сот.'
    });
  }

  getBoolItems () {
    return new OrderedMap({
      hasPhoto: 'c фото',
      isMls: 'млс',
      withoutComplaint: 'без жалоб',
      onlyFromBuilder: 'от застройщика',
      isResale: 'вторичка',
      isNewBuilding: 'новостройки',
      isMortgageAvailable: 'ипотека',
      isClearSale: 'чистая продажа',
      isExchange: 'обменный вариант',
      isFirstLine: 'первая линия',
      isDetachedBuilding: 'отдельно стоящее здание',
      ownEntrance: 'отдельный вход',
      hasSecurityProtection: 'охрана',
      hasRepairPit: 'смотровая яма',
      hasCellar: 'погреб',
      hasElectricity: 'электричество',
      hasHeating: 'отопление',
      hasWater: 'водоснабжение',
      hasCanalization: 'канализация',
      hasGas: 'газ',
      hasGarage: 'гараж',
      hasBathhouse: 'баня',
      hasOutbuildings: 'хоз. постройки',
      needDeposit: 'депозит',
      includedUtilities: '+коммунальные услуги',
      description: 'текст в описании',
      isDealCompleted: 'только проданные'
    });
  }
}

export default PillBuilder;



// WEBPACK FOOTER //
// ./src/classes/builder/pillBuilder.js